(function () {
  'use strict';

  angular.module('ringbaPortal').component('changelogEntry', {
    controller: ChangelogEntryController,
    controllerAs: 'vm',
    bindings: {
      changelog: '<'
    },
    templateUrl: '/scripts/shared/components/changelog/changelog-entry/changelog-entry.view.html'
  });

  function ChangelogEntryController(
    changelogDeltaService
  ) {
    'ngInject';

    const vm = this;

    vm.viewData = {
      actionClass: ''
    };

    vm.$onInit = onInit;

    function onInit() {
      vm.viewData = changelogDeltaService.getActionViewData(vm.changelog);
      vm.statement = changelogDeltaService.getActionStatement(vm.changelog);
    }

  }
})();
